/* eslint-disable camelcase,no-undef */
__webpack_public_path__ = AC.config.hosts.assets + '/js/website/';
